/**
 * Platform compliance constants — ToS URLs, character limits, and YouTube categories.
 * Used by PublishSettingsModal and platform settings panels.
 */

export const PLATFORM_TOS = {
  YOUTUBE: 'https://www.youtube.com/t/terms',
  TIKTOK: 'https://www.tiktok.com/legal/terms-of-service',
  INSTAGRAM: 'https://help.instagram.com/581066165581870',
  FACEBOOK: 'https://www.facebook.com/legal/terms',
  TWITTER: 'https://twitter.com/tos',
};

export const PLATFORM_LIMITS = {
  TWITTER: { maxChars: 280 },
  INSTAGRAM: { maxCaptionChars: 2200, maxHashtags: 30 },
  TIKTOK: { maxCaptionChars: 2200 },
  YOUTUBE: { maxTitleChars: 100, maxDescriptionChars: 5000 },
  FACEBOOK: { maxPostChars: 63206 },
};

export const YOUTUBE_CATEGORIES = [
  { id: '1', name: 'Film & Animation' },
  { id: '2', name: 'Autos & Vehicles' },
  { id: '10', name: 'Music' },
  { id: '15', name: 'Pets & Animals' },
  { id: '17', name: 'Sports' },
  { id: '19', name: 'Travel & Events' },
  { id: '20', name: 'Gaming' },
  { id: '22', name: 'People & Blogs' },
  { id: '23', name: 'Comedy' },
  { id: '24', name: 'Entertainment' },
  { id: '25', name: 'News & Politics' },
  { id: '26', name: 'Howto & Style' },
  { id: '27', name: 'Education' },
  { id: '28', name: 'Science & Technology' },
];

export const TIKTOK_PRIVACY_LABELS = {
  PUBLIC_TO_EVERYONE: 'Public',
  MUTUAL_FOLLOW_FRIENDS: 'Friends',
  FOLLOWER_OF_CREATOR: 'Followers',
  SELF_ONLY: 'Only Me',
};

export const TIKTOK_POLICY_URLS = {
  MUSIC_USAGE: 'https://www.tiktok.com/legal/music-usage-confirmation',
  BRANDED_CONTENT: 'https://www.tiktok.com/legal/branded-content-policy',
};

export const FACEBOOK_PRIVACY_OPTIONS = [
  { value: 'EVERYONE', label: 'Public' },
  { value: 'ALL_FRIENDS', label: 'Friends' },
  { value: 'SELF', label: 'Only Me' },
];
